<template>
  <VDialogV3
    id="transport-order-requisites-dialog"
    position="right"
    :entity="localTransportOrder"
    @submit="save"
  >
    <!-- Тип ЗТК -->
    <section>
      <header>Тип заявки</header>

      <VSelectV2
        v-model="localTransportOrderType"
        label="Тип ЗТК"
        required
        :data="TransportOrder.types"
      />
    </section>


    <!-- Транспорт — скрыт для single_sender -->
    <template v-if="showVehicle === true">
      <hr>

      <section>
        <header>Транспорт</header>
        <VSelectV2
          v-model="localTransportOrder.vehicle"
          label="Транспортное средство"
          :required="localTransportOrder.isService"
          :data="vehicleSource"
        >
          <!-- <template #helper-text>
            {{ localTransportOrder?.vehicle?.toString() || '--' }}
          </template> -->
        </VSelectV2>

        <VInput
          v-model="localTransportOrder.vehicleRegistrationNumber"
          label="Регистрационный номер"
          layout="vertical"
        />

        <VInput
          v-model="localTransportOrder.driverFullName"
          label="ФИО водителя"
          layout="vertical"
        />
      </section>
    </template>
    <hr>

    <!-- Основное -->
    <section>
      <header>Основное</header>
      <VSelectV2
        ref="delivererSelect"
        label="Транспортная компания"
        v-model="localTransportOrder.deliverer"
        :required="localTransportOrder.isService"
        :data="({pattern}) =>  PartnersService.getList({ pattern, types: ['deliverer'] })"
      >

        <template #helper-text>
          <span>Если нужной транспортной компании нет, вы можете её </span>
          <VLink @click="showDelivererCreateDialog">создать</VLink>
        </template>

      </VSelectV2>
      <VInput
        ref="trackingNumberInput"
        v-model="localTransportOrder.trackingNumber"
        label="Трек-номер"
        layout="vertical"
        :max-length="100"
      />

      <VDateInput
        ref="pickupDatePlannedInput"
        label="Плановая дата забора груза"
        layout="vertical"
        required
        :value="localTransportOrder.pickupDatePlanned"
        @input="setPickupDatePlanned"
        :validate-method="value => localTransportOrder.validatePickupDatePlanned(value)"
      />

      <VDateInput
        ref="arrivalDatePlannedInput"
        v-model="localTransportOrder.arrivalDatePlanned"
        label="Плановая дата прибытия груза"
        layout="vertical"
        required
        :validate-method="value => localTransportOrder.validateArrivalDatePlanned(value)"
      />

      <VSwitch
        ref="isConfirmed"
        v-model="localTransportOrder.isConfirmed"
        checked-label="Утверждена"
        unchecked-label="Не утверждена"
        theme="slider"
      />

      <VTextarea
        v-model="localTransportOrder.note"
        label="Примечание"
        layout="vertical"
      >
      <template #helper-text>
        Будет отражено в портальной задаче и в заявке Excel
      </template>
    </VTextarea>
    </section>

    <hr>

    <!-- Фактические даты -->
    <section>
      <header>Фактические даты доставки</header>
      <VDateInput
        ref="pickupDateActualInput"
        v-model="localTransportOrder.pickupDateActual"
        label="Фактическая дата забора"
        layout="vertical"
        clearable
        :disabled="isActualDataFormDisabled"
        :required="localTransportOrder.isFinished"
      />

      <VDateInput
        ref="arrivalDateActualInput"
        v-model="localTransportOrder.arrivalDateActual"
        label="Фактическая дата прибытия"
        layout="vertical"
        clearable
        :disabled="isActualDataFormDisabled"
        :required="localTransportOrder.isFinished"
        :validate-method="value => localTransportOrder.validateArrivalDateActual(value)"
      />
    </section>
    <section class="declared-cost-form">
      <div>
        Объявленная ценность:
        {{ localTransportOrder.declaredCost?.format(transportOrder.declaredCostCurrencyCode) || '--' }}
      </div>
    </section>

    <!-- Простои транспорта — скрыты для single_sender -->
      <hr>
      <section>
        <header>Простои транспорта</header>
        <ul v-if="$core.utils.isNotEmptyArray(localTransportOrder.downtimes)">
          <li
            v-for="(downtime, index) in localTransportOrder.downtimes"
            :key="downtime.id ?? index"
            class="downtime-item"
          >
            <div class="description">
              <span>{{ downtime.reason || '--' }}</span>
              <span>{{ downtime.period?.toString() ?? '--' }}</span>
              <span>{{ downtime.cost.format(downtime.currencyCode) }}</span>
            </div>

            <div class="buttons-group">
              <VButton material="edit" @click="editDowntime(downtime, index)"/>
              <VButton material="delete" @click="deleteDowntime(downtime, index)"/>
            </div>
          </li>
        </ul>
        <span v-else class="description">Нет простоев</span>
        <footer>
          <VLink
            :disabled="localTransportOrder.isExisting === false"
            @click="addDowntime"
            material="add"
          >
            Добавить простой
          </VLink>
        </footer>
      </section>


    <template v-if="showTransportCost === true">
      <hr>
      <!-- Стоимость перевозки -->
      <section>
        <header>Стоимость перевозки</header>
        <VInputNumberRusV2
          v-model="localTransportOrder.transportCostPlanned"
          :type="Sum"
          label="Плановая стоимость"
          layout="vertical"
        />
        <VInputNumberRusV2
          v-model="localTransportOrder.transportCostActual"
          :type="Sum"
          label="Фактическая стоимость"
          layout="vertical"
        />
      </section>
    </template>


    <!-- Уведомления и портальная задача — только для single_sender, только создание -->
    <template v-if="localTransportOrder.isExisting === false && localTransportOrder.isSingleSender === true">
      <hr>
      <section class="send-email">
        <VCheckbox v-model="isSendToEmail" @input="onToggleSendEmail">
          Отправить уведомление на почту
        </VCheckbox>
      </section>

      <section v-if="isSendToEmail === true">
        <SWMailingList
          :receivers="localReceiversMail"
          @update="updateReceivers"
        />
      </section>

      <hr>

      <template v-if="transportOrder.receiver.id === $core.sibWellPartner.id">
        <section>
          <VCheckbox
            v-model="isCreateSWPortalTask"
            :disabled="$core.utils.isNullOrUndefined(localTransportOrder.pickupDatePlanned) === true"
            @input="onTogglePortalTask"
          >
            Создать задачу на портале
            <template v-if="$core.utils.isNullOrUndefined(localTransportOrder.pickupDatePlanned) === true" #helper-text>
              Чтобы создать задачу, нужно заполнить плановую дату забора груза
            </template>
          </VCheckbox>
        </section>

        <section v-if="$core.utils.isNullOrUndefined(localSWPortalTask) === false && isCreateSWPortalTask === true">
          <SWPortalTaskForm
            hide-header
            :sw-portal-task="localSWPortalTask"
          />
        </section>
      </template>
    </template>

    <!-- Портальная задача — только для первого покупателя, только для single_sender, только редактирование -->
    <template v-if="
       localTransportOrder.isExisting === true
       && localTransportOrder.isSingleSender === true
       && transportOrder?.receiver?.id === $core.sibWellPartner.id
    ">
      <hr>
      <section>
        <header>Задача на корпоративном портале</header>
        <VLink
          v-if="$core.utils.isNullOrUndefined(transportOrder.swPortalTask) === false"
          :href="'https://cp.siberianhealth.com/task3/view.php?id=' + transportOrder.swPortalTask.id"
          target="_blank"
        >
          Задача №{{ transportOrder.swPortalTask.id }}
          <template v-if="$core.utils.isNullOrUndefined(transportOrder.swPortalTask.createdAt) === false">
            от {{ $core.utils.date.format(transportOrder.swPortalTask.createdAt) }}
          </template>
        </VLink>
        <template
          v-else-if="transportOrder.isFinished === false && $core.currentPartner?.isLSZ === true">
          Задачи нет, вы можете её
          <VLink material="add" @click="openSWPortalTaskDialog">создать</VLink>
        </template>
        <template v-else>Задачи нет</template>
      </section>

      <hr>

      <section class="assembly-data">
        <header>Отгрузочные документы на сборочные листы</header>
        <template v-if="assemblies.length > 0">
          <article
            v-for="(assembly, index) in assemblies"
            :key="assembly.id + '_' + index"
          >
            <div class="title">
              Сборочный лист №{{ assembly.id }} от {{ $core.utils.date.format(assembly.createdAt) }}
            </div>
            Отгружен:
            <template v-if="assembly.isShipped === true">
                <span class="description">
                  Да, {{ assembly.isShippedEntirely === true ? 'полностью' : 'частично' }}
                </span>
            </template>
            <template v-else>Нет</template>
          </article>
        </template>
        <template v-else>Отсутствуют</template>
      </section>
    </template>

    <template v-if="showSender === true">
      <hr>
      <!-- Участники — отправитель -->
      <section>
        <header>Отправитель</header>

        <template v-if="localTransportOrder.isReturn === true">
          <VSelectV2
            v-model="localTransportOrder.sender"
            label="Отправитель"
            :data="({ pattern }) => PartnersService.searchBuyers(pattern)"
          />
        </template>
        <template v-else>
          <VSelectV2
            v-model="localTransportOrder.sender"
            label="Отправитель"
            :data="({ pattern }) => PartnersService.searchSellers(pattern)"
          />
        </template>

        <VSelectV2
          v-model="localTransportOrder.senderCompany"
          label="Юр лицо отправителя"
          :data="senderCompanySource"
        />

        <VSelectV2
          v-if="showSenderStore === true"
          v-model="localTransportOrder.senderStore"
          label="Склад отправителя"
          :data="senderStoreSource"
        />
        <!--              :required="localTransportOrder.isOrderPositionPickup || localTransportOrder.isReturn || localTransportOrder.isInternal"-->

      </section>
    </template>

    <!-- Таможня: дедлайн текущего этапа, статус и комментарий — только для зарубежного поставщика -->
    <template v-if="localTransportOrder.isForeign === true">
      <hr>

      <section>
        <header>Таможня</header>

        <VDateInput
          v-model="localTransportOrder.deadline"
          label="Дедлайн"
          layout="vertical"
          clearable
        />

        <VSelectV2
          v-model="localTransportOrder.borderStatus"
          label="Таможенный статус"
          layout="vertical"
          :data="TransportOrder.borderStatuses"
        />

        <VTextarea
          v-model="localTransportOrder.comment"
          label="Комментарий"
          layout="vertical"
        />
      </section>
    </template>

    <!-- Склад перевозчика — скрыт для internal, service, single_sender и для Намангана -->
    <template v-if="showDelivererStore === true">
      <hr>
      <section>
        <VSelectV2
          label="Склад перевозчика"
          v-model="localTransportOrder.delivererStore"
          :data="delivererStoreSource"
        />
      </section>

    </template>

    <hr>

    <!-- Получатель -->
    <section>
      <header>Получатель</header>

      <template v-if="localTransportOrder.isReturn === true">
        <VSelectV2
          v-model="localTransportOrder.receiver"
          label="Получатель"
          required
          :data="({pattern}) => PartnersService.searchSellers(pattern)"
        />
      </template>
      <template v-else>
        <VSelectV2
          v-model="localTransportOrder.receiver"
          label="Получатель"
          required
          :data="({pattern}) => PartnersService.searchBuyers(pattern)"
        />
      </template>

      <VSelectV2
        required
        v-model="localTransportOrder.receiverCompany"
        label="Юр лицо получателя"
        :data="receiverCompanySource"
      />

      <VSelectV2
        v-model="localTransportOrder.receiverStore"
        label="Склад получателя"
        :required="localTransportOrder.isService === false"
        :data="receiverStoreSource"
      />

      <VSelectV2
        v-model="localTransportOrder.responsibleReceiver"
        required
        label="Ответственный от получателя"
        placeholder="Введите ФИО ответственного"
        :data="responsibleReceiverSource"
      />
    </section>
  </VDialogV3>
</template>

<style lang="scss" src="./TransportOrderRequisitesDialog.scss"/>

<script lang="ts">

import Core                      from '@/core/Core';
import SWPortalTask              from '@/domains/SWPortalTask/SWPortalTask';
import PersonsService            from '@/domains/Persons/PersonsService';
import PartnersService           from '@/domains/Partners/PartnersService';
import TransportOrder            from '@/domains/TransportOrders/TransportOrder';
import TransportDowntime         from '@/domains/TransportDowntime/TransportDowntime';
import VehiclesService           from '@/domains/Vehicles/VehiclesService';
import StoresService             from '@/domains/Stores/StoresService';
import CompaniesService          from '@/domains/Companies/CompaniesService';
import TransportDowntimesService from "@/domains/TransportDowntime/TransportDowntimesService";
import Assembly                  from '@/domains/Assemblies/Assembly';
import Sum                       from '@/core/types/Sum'
import Partner                   from "@/domains/Partners/Partner";
import SWPortalTasksService      from "@/domains/SWPortalTask/SWPortalTasksService";

import SWPortalTaskForm
  from '@/domains/SWPortalTask/components/SWPortalTaskCreateDialog/SWPortalTaskForm';
import SWMailingList
  from "@/domains/TransportOrders/components/SWMailingListCreateDialog/SWMailingList.vue";

export default defineComponent({
  name: 'TransportOrderRequisitesDialog',

  components: {
    SWPortalTaskForm,
    SWMailingList,
  },

  props: {
    transportOrder: {
      type: Object as PropType<TransportOrder>,
      required: true,
    },
    swPortalTask: {
      type: Object,
      default: null,
    },
    receivers: {
      type: Array,
      default: null,
    },
  },


  setup() {
    return {
      PartnersService,
      TransportOrder,
      Sum,
      SWPortalTasksService,
    }
  },

  data() {
    const localTransportOrder = this.$core.utils.cloneDeepWithReference(this.transportOrder, ['positions']);
    localTransportOrder.calculateDeclaredCost();

    /**
     * Правило прелоада зависимых источников документа:
     * - новый — preloadOnMount: опции готовы до первого клика,
     *   контрагентские подгрузятся сами при выборе партнёра;
     * - существующий — preloadOnFocus: шанс, что реквизиты станут
     *   менять, низок — впустую не грузим.
     */
    const isNewDocument = this.transportOrder.isExisting === false;

    const vehicleSource = this.$core.loader.select<TransportOrder>(({ pattern }) =>
      VehiclesService.getList({ pattern })
    )
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    const senderCompanySource = this.$core.loader.select<TransportOrder>(({sender}) =>
      CompaniesService.getList({ partnerId: sender.id })
    )
      .dependsOn({sender: () => this.localTransportOrder.sender})
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    const senderStoreSource = this.$core.loader.select<TransportOrder>(({sender}) =>
      StoresService.getList({ partnerId: sender.id })
    )
      .dependsOn({
        sender:        () => this.localTransportOrder.sender,
        senderCompany: () => this.localTransportOrder.senderCompany,
      })
      .default((options) => this.localTransportOrder.findDefaultSenderStore(options))
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    /** Перевалочный пункт — наш склад, а не склад перевозчика, поэтому от deliverer не зависит */
    const delivererStoreSource = this.$core.loader.select<TransportOrder>(() =>
      StoresService.getList({ partnerId: this.$core.sibWellPartner.id })
    )
      .default((options) => this.localTransportOrder.findDefaultDelivererStore(options))
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    const receiverCompanySource = this.$core.loader.select<TransportOrder>(({receiver}) =>
      CompaniesService.getList({ partnerId: receiver.id })
    )
      .dependsOn({receiver: () => this.localTransportOrder.receiver})
      .default((options) => this.localTransportOrder.findDefaultReceiverCompany(options))
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    const receiverStoreSource = this.$core.loader.select<TransportOrder>(({receiver}) =>
      StoresService.getList({ partnerId: receiver.id })
    )
      .dependsOn({
        receiver:        () => this.localTransportOrder.receiver,
        receiverCompany: () => this.localTransportOrder.receiverCompany,
      })
      .default((options) => this.localTransportOrder.findDefaultReceiverStore(options))
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    return {
      /**
       * TODO
       * cloneDeepWithReference вместо cloneDeep, так как проблемы из-за клонирования shipment,
       * особенно calculateSum, который происходит при клонировании,
       * не придумал как точечно это исправить не проходясь по всему стеку
       * */

      vehicleSource,

      senderCompanySource,
      senderStoreSource,

      delivererStoreSource,

      receiverCompanySource,
      receiverStoreSource,

      responsibleReceiverSource: PersonsService.responsibleSource(isNewDocument),

      localTransportOrder: localTransportOrder,
      localSWPortalTask: Core.utils.isNullOrUndefined(this.swPortalTask) === false ? Core.utils.cloneDeep(this.swPortalTask) : null,
      localReceiversMail: Core.utils.isNullOrUndefined(this.receivers) === false ? Core.utils.cloneDeep(this.receivers) : null,

      isCreateSWPortalTask: Core.utils.isNullOrUndefined(this.swPortalTask) === false,
      isSendToEmail: Core.utils.isNullOrUndefined(this.receivers) === false,
    };
  },

  computed: {
    localTransportOrderType: {
      get(): { id: string; name: string } | undefined {
        return TransportOrder.types.get(this.localTransportOrder.type);
      },
      set(value: { id: string; name: string }): void {
        this.localTransportOrder.type = value?.id;
      },
    },

    isActualDataFormDisabled(): boolean {
      return this.localTransportOrder?.isConfirmed === false || this.localTransportOrder?.isFinished === true;
    },

    assemblies(): Assembly[] {
      return this.localTransportOrder.positions
        .filter((p: any) => p.positionType === 'Assembly')
        .map((p: any) => p.document);
    },

    /**
     * Отправитель скрыт для consolidated, service, single_sender.
     * У internal отправитель показывается: склады отправителя грузятся по sender,
     * без него список складов не загрузится.
     */
    showSender(): boolean {
      // у консолидации много поставщиков, машина объезжает сразу многих, нет одного конкретного
      return this.localTransportOrder.isConsolidated === false
        // Не перевоз товара, смысла в отправителе нет
        && this.localTransportOrder.isService === false
        // Мы в обычной не показывали отправителя
        && this.localTransportOrder.isSingleSender === false;
    },

    /** Склад отправителя скрыт для consolidated, service */
    showSenderStore(): boolean {
      // у консолидации много поставщиков, машина объезжает сразу многих, нет одного конкретного
      return this.localTransportOrder.isConsolidated === false
        // Не перевоз товара, смысла в отправителе нет
        && this.localTransportOrder.isService === false;
    },

    /** Транспорт скрыт для single_sender — обычная ЗТК не подразумевает выбор ТС */
    showVehicle(): boolean {
      return this.localTransportOrder.isSingleSender === false;
    },

    /** Склад перевозчика скрыт для internal, service, single_sender и для Намангана */
    showDelivererStore(): boolean {
      // перевалочный пункт не нужен для внутренних перемещений рохли
      return this.localTransportOrder.isInternal === false
        && this.localTransportOrder.isService === false
        // В обычных ЗТК у нас никогда не было перевалочного пункта
        && this.localTransportOrder.isSingleSender === false
        // У Намангана перевалочного пункта нет
        && this.$core.currentPartner.isNamangan === false;
    },

    /** Стоимость перевозки скрыта для обычной ЗТК */
    showTransportCost(): boolean {
      return this.localTransportOrder.isSingleSender === false;
    },

  },

  methods: {
    addDowntime(): void {
      const downtime = TransportDowntime.fromTransportOrder(this.localTransportOrder.id);

      this.$core.dialogs.TransportDowntimeDialog.show({downtime}, {
        [TransportDowntime.Events.Created]: (createdDowntime: TransportDowntime) => {
          this.localTransportOrder.downtimes.push(createdDowntime);

          this.$emit(TransportDowntime.Events.Updated, this.localTransportOrder)
        },
      });
    },

    editDowntime(downtime: TransportDowntime, index: number): void {
      this.$core.dialogs.TransportDowntimeDialog.show({downtime}, {
        [TransportDowntime.Events.Updated]: (updatedDowntime: TransportDowntime) => {
          this.localTransportOrder.downtimes[index] = updatedDowntime;

          this.$emit(TransportDowntime.Events.Updated, this.localTransportOrder)
        },
      });
    },

    async deleteDowntime(downtime: TransportDowntime, index: number): Promise<void> {
      const confirmed = await this.$core.confirm('Удалить простой?');

      if (confirmed === true) {
        const success = await TransportDowntimesService.delete(downtime.id);

        if (success === true) {
          this.localTransportOrder.downtimes.splice(index, 1);

          this.$emit(TransportDowntime.Events.Updated, this.localTransportOrder);
        }
      }
    },

    async save(): Promise<void> {
      this.$emit('save', {
        transportOrder: this.localTransportOrder,
        SWPortalTask: this.localSWPortalTask,
        receivers: this.localReceiversMail,
      });
      this.$core.dialogs.TransportOrderRequisitesDialog.resolve();
    },

    updateReceivers(receivers: any[]): void {
      this.localReceiversMail = receivers;
    },

    onToggleSendEmail(value: boolean): void {
      if (value === true) {
        this.localReceiversMail = SWPortalTasksService.getReceivers();
      } else {
        this.localReceiversMail = null;
      }
    },

    setPickupDatePlanned(value: any): void {
      this.localTransportOrder.pickupDatePlanned = value;

      if (Core.utils.isNullOrUndefined(this.localSWPortalTask) === false) {
        this.localSWPortalTask.updateTitle();
      }
    },

    onTogglePortalTask(value: boolean): void {
      if (value === true) {
        this.localSWPortalTask = SWPortalTask.fromTransportOrder(this.localTransportOrder);
      } else {
        this.localSWPortalTask = null;
      }
    },

    showDelivererCreateDialog(): void {
      this.$core.dialogs.DelivererCreatePopup.show({
        target:   this.$refs.delivererSelect.$el,
        onCreate: (deliverer: Partner) => {
          this.localTransportOrder.deliverer = deliverer;
        },
      });
    },

    openSWPortalTaskDialog(): void {
      this.$core.dialogs.SWPortalTaskCreateDialog.show(
        { transportOrder: this.localTransportOrder },
        { [SWPortalTask.Events.Created]: () => this.$emit('save') },
      );
    },

    clearReceiverSection(): void {
      this.localTransportOrder.receiver = null;
      this.localTransportOrder.receiverCompany = null;
      this.localTransportOrder.receiverStore = null;
    },

  },

  watch: {
    'localTransportOrder.type'(newType: string, oldType: string): void {
      if (newType === 'return' && oldType !== 'return') {
        this.clearReceiverSection();
      }
    },
  },
});
</script>